import { FlexBox } from 'components';
import { ButtonCountP01 } from '../intendedComponents';

const Prac01 = () => {
  return (
    <FlexBox wrapped="wrap">
      <ButtonCountP01 />
      <ButtonCountP01 />
      <ButtonCountP01 />
      <ButtonCountP01 />
      <ButtonCountP01 />
    </FlexBox>
  );
};

export default Prac01;
